import { render, staticRenderFns } from "./KirvanoUpsellVideoV2.vue?vue&type=template&id=d866273e&lang=br"
import script from "./KirvanoUpsellVideoV2.vue?vue&type=script&lang=js"
export * from "./KirvanoUpsellVideoV2.vue?vue&type=script&lang=js"
import style0 from "./KirvanoUpsellVideoV2.vue?vue&type=style&index=0&id=d866273e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports